import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [subscribe, setSubscribe] = useState(true);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("password must be at least 6 characters");
    setLoading(true);
    try {
      await signup(name, email, password, subscribe);
      toast.success("you're in. start with episode 1.");
      nav("/episodes");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-ink min-h-screen flex items-center justify-center px-5 py-12" data-testid="signup-page">
      <div className="w-full max-w-md">
        <p className="scribble text-hotpink text-2xl mb-2 rotate-[-2deg] inline-block">first 10 episodes — free</p>
        <h1 className="brush-title text-5xl md:text-6xl text-white mb-8">START <span className="text-hotpink">LISTENING.</span></h1>

        <form onSubmit={submit} className="bg-coal border border-white/10 p-7 space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">your name (or alias)</label>
            <input data-testid="signup-name" required value={name} onChange={(e) => setName(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none" placeholder="Joey" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">email</label>
            <input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none" placeholder="you@dating.disaster" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-white/60 mb-2">password</label>
            <input data-testid="signup-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-ink border border-white/15 px-4 py-3 text-white font-outfit focus:border-hotpink focus:outline-none" placeholder="min 6 characters" />
          </div>
          <label className="flex items-start gap-3 cursor-pointer text-white/80 font-outfit text-sm" data-testid="signup-subscribe-label">
            <input type="checkbox" checked={subscribe} onChange={(e) => setSubscribe(e.target.checked)} data-testid="signup-subscribe" className="mt-1 accent-hotpink w-4 h-4" />
            <span>
              <span className="font-bold">Send me new episode alerts.</span>
              <span className="block scribble text-hotpink text-base">never miss a date i shouldn&rsquo;t have gone on. uncheck if you&rsquo;d rather not.</span>
            </span>
          </label>
          <button type="submit" disabled={loading} data-testid="signup-submit"
            className="w-full bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-sm px-6 py-4 shadow-[4px_4px_0px_#FFFFFF] hover:shadow-[6px_6px_0px_#FFFFFF] transition-all disabled:opacity-60">
            {loading ? "..." : "make my account"}
          </button>
          <p className="text-white/60 text-sm font-outfit text-center">
            already here? <Link to="/login" data-testid="signup-to-login" className="text-hotpink underline underline-offset-4">log in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
